import reducer from "../core/reducer";

import {
  GET_BUSINESS_RULES_VISIBLE_FIELDS,
  GET_BUSINESS_RULES_VISIBLE_FIELDS_FAIL,
  GET_BUSINESS_RULES_VISIBLE_FIELDS_SUCCESS,
} from "./constants";

export default reducer({
  actions: [
    {
      name: 'getVisibleFieldsRequest',
      action: GET_BUSINESS_RULES_VISIBLE_FIELDS,
      endPoint: 'be/1.0/legal-compliance-business-rules/visible-fields',
      mutations: {
        fail: GET_BUSINESS_RULES_VISIBLE_FIELDS_FAIL,
        success: GET_BUSINESS_RULES_VISIBLE_FIELDS_SUCCESS,
      },
    },
  ]
});
